import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  // {
  //   path: '/loginView',
  //   component: () => import('../views/loginView.vue'),
  // },
  {
    path: '/b2bView',
    component: () => import('../components/b2bView.vue'),
    meta: {
      auth: true
    },
  }
  ,
  {
    path: '/BIView',
    component: () => import('../components/BIView.vue'),
    meta: {
      auth: true
    },
  },
  {
    path: '/liveBroadcast',
    component: () => import('../components/liveBroadcast.vue'),
    meta: {
      auth: true
    },
  }
  ,
  {
    path: '/crmView',
    component: () => import('../components/crmView.vue'),
    meta: {
      auth: true
    },
  },
  {
    path: '/OmsView',
    component: () => import('../components/OmsView.vue'),
    meta: {
      auth: true
    },
  },
  {
    path: '/WmsView',
    component: () => import('../components/WmsView.vue'),
    meta: {
      auth: true
    },
  }
  ,
  {
    path: '/TmsView',
    component: () => import('../components/TmsView.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/erpView',
    component: () => import('../components/erpView.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/jcView',
    component: () => import('../components/jcView.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/yyfxView',
    component: () => import('../components/yyfxView.vue'),
    meta: {
      auth: true
    }
  },
  {
    path: '/',
    component: HomeView,
    meta: {
      auth: true
    },
    children: [
      {
        path: '',
        name: 'home',
        component: () => import('../views/EcologyView.vue'),
        meta: {
          auth: true
        },
      },
      {
        path: '/logisticsView',
        name: 'logisticsView',
        component: () => import('../views/logisticsView.vue'),
        meta: {
          auth: true
        },
      },
      {
        path: '/logoPage',
        component: () => import('../views/logoPage.vue'),
        meta: {
          auth: true
        },
      },
      {
        path: '/onlineRetailers',
        name: 'onlineRetailers',
        component: () => import('../views/onlineRetailers.vue'),
        meta: {
          auth: true
        },
      },
      {
        path: '/technologyView',
        name: 'technologyView',
        component: () => import('../views/technologyView.vue'),
        meta: {
          auth: true
        },
      },
      {
        path: '/ECommerceAlliance',
        name: 'ECommerceAlliance',
        component: () => import('../views/ECommerceAlliance.vue'),
        meta: {
          auth: true
        },
      },
      {
        path: '/memoirView',
        name: 'memoirView',
        component: () => import('../views/memoirView.vue'),
        meta: {
          auth: true
        },
      },
    ]
  }
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // const token = localStorage.getItem('token')
  // if (to.meta.auth) {
  //   if (token) {
  //     next();
  //   } else {
  //     next('/loginView')
  //   }
  // } else {
  //   next();
  // }
  next();
})

export default router
